export default {
  veiculos: [],
  selectedVeiculo: ''
}
